import { toast } from "react-toastify";
import { formatDate } from "../../utils/rawData/dateValues";
import { PercetageColor, PlanBackgroundColor, GetDynamicColor, infoEnviadaMapColor, delayResponsibleMapColor, capacitacionHechaMapColor, statusColorMap, vipClientColor } from "../../utils/GetTextColor";
import DetailsButton from "../ui/components/DetailsButton";
import { FaCalendar, FaComment, FaEye, FaEyeSlash, FaFileAlt } from "react-icons/fa";
import { SiGoogledrive } from "react-icons/si";
import Tooltip from "../ui/ToolTip";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import React, { useRef, useState, useEffect } from "react";
import HandleUpdateSelect from "../../utils/HandleUpdateSelect";
import { webServiceStatus } from "../../utils/rawData/serviceStatus";
import IdButton from "../ui/components/IdButton";
import CopyToClipBoard from "../../utils/CopyToClipBoard";
import DinamicBoxButton from "../ui/components/DinamicBoxButton";
import OpcionesRecompraPotencial from "../../utils/plainValues/OpcionesRecompraPotencial";
import ResponsablesRetraso from "../../utils/plainValues/ResponsablesRetraso";
import { EnfoqueWebOptions } from "../../utils/rawData/enfoqueWebOptions";
import { vipClientValues } from "../../utils/rawData/vipClientValues";
import { createPortal } from "react-dom";
import DrawerCotizacionCalendarioPagosDetails from "../calendarioPagos/DrawerCotizacionCalendarioPagosDetails";

const WebRowItemContainer = ({ areaWorkers, isUserArea, sticky, second, serviceData, key, c, activeCols, shouldShowColumn, stickyOffsets, user, permissions, setOpenModalDescription, setSelectedService, setOpenModalComments, setOpenModalClientData, setSelectedClientData, webServices, setClients, onOpenMeets, onOpenSolicitudRevisiones }) => {

  const [s, setS] = useState(serviceData)
  
  // Mantener sincronizado el estado local con los cambios del padre
  useEffect(() => {
    setS(serviceData)
  }, [serviceData])
  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  // Drawer cotización
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dataDrawer, setDataDrawer] = useState(null);

  const handleOpenDrawer = async (id) => {
    try {
      const response = await axios.get(`${BACKEND}/api/cotizaciones/${id}`)
      setDataDrawer(response.data)
      setOpenDrawer(true)
    } catch (error) {
      toast.error("Error al obtener la cotización")
    }
  }

  const formStatus = s.form ? s.form.respondido ? "Respondido" : "No respondido" : "No asignado"
  // const clientType = s.cotizacion?.cliente?.tipoCliente ? s.cotizacion?.cliente?.tipoCliente : "No definido"
  // const facturacion = s.facturacion ? s.facturacion : "No definido"
  const checklistCompleted = s.checklistCompleted || s.checkList === "Si" ? "Si" : "No"

  const linkDesarrollo = s?.links?.find((l) => l.titulo === "Link demo")?.url
  const linkOficial = s?.links?.find((l) => l.titulo === "Link web oficial")?.url

  const linkDisenioGrafico = s.linkDisenioGrafico || ""
  
  const webReferencia = s.webReferencia
  const copiaSeguridadRef = s.copiaSeguridadReferencia

  const linkCapacitacion = s.linkCapacitacion

  const folderCreated = s.folderCreated || false
  const folderId = s.folderId || ""
  const driveUrl = folderCreated && folderId ? `https://drive.google.com/drive/folders/${folderId}` : null

  // Modificación de seleccionables, ya no es solo lectura
  const handleUpdateField = async (field, newStatus) => { // Cambiar el campo
    const changeHistory = s.historialCambios ? [...s.historialCambios] : [];

    const newChange = {
      worker: user,
      field: field,
      oldValue: s[field],
      newValue: newStatus,
      date: new Date().toISOString(),
    };

    changeHistory.push(newChange);

    const transformedHistory = changeHistory.map(change => ({
      ...change,
      worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
    }));

    try {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${s.id}`, {
        [field]: newStatus === "Seleccionar" ? null : newStatus,
        historialCambios: transformedHistory, // Enviar el array actualizado
      });

      // Crear el servicio actualizado
      const updatedService = {
        ...s,
        [field]: newStatus,
        historialCambios: changeHistory,
      };

      // Actualizar el estado local
      setS(updatedService);

      // Actualizar el servicio específico en el array de clientes
      setClients((prevClients) => 
        prevClients.map(client => 
          client.id === c.id 
            ? {
                ...client,
                services: client.services.map(service => 
                  service.id === s.id ? updatedService : service
                )
              }
            : client
        )
      );

      toast.success("Estado actualizado con éxito");
    } catch (error) {
      console.error(error);
      toast.error("Error al actualizar el estado");
    }
  };

  // Modificación de inputs, ya no es solo lectura
  const handleUpdateDate = (field, newDate) => { // Cambiar la fecha con lógica de debouncer

    setS((prevData) => ({
      ...prevData,
      [field]: newDate,
    }));

    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {
      try {
        const changeHistory = s.historialCambios ? [...s.historialCambios] : [];

        const newChange = {
          worker: user,
          field: field,
          oldValue: s[field],
          newValue: newDate,
          date: new Date().toISOString(),
        };

        changeHistory.push(newChange);

        const transformedHistory = changeHistory.map(change => ({
          ...change,
          worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
        }));

        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${s.id}`, {
          [field]: newDate || null,
          historialCambios: transformedHistory, // Enviar el array actualizado
        });

        // Crear el servicio actualizado
        const updatedService = {
          ...s,
          [field]: newDate,
          historialCambios: changeHistory,
        };

        // Actualizar el estado local
        setS(updatedService);

        // Actualizar el servicio específico en el array de clientes
        setClients((prevClients) => 
          prevClients.map(client => 
            client.id === c.id 
              ? {
                  ...client,
                  services: client.services.map(service => 
                    service.id === s.id ? updatedService : service
                  )
                }
              : client
          )
        );

      } catch (error) {
        console.log(error);
        toast.error("Error al actualizar la fecha");
      }
    }, 500); // Esperar 0.5 sec luego de que el usuario deja de escribir
  };

  const handleFreezeService = async (serviceId) => {
    try {
      setSelectedService(s)
      setOpenModalComments(true, { type: "updateStatus" })
    } catch (error) {
      console.log(error);
      toast.error("Error al congelar el servicio");
    }
  }

  // Column definitions (ordered). IDs are assigned automatically as index + 1
  // to match the `colsWithIds` approach you used in ProyectosWebs.jsx.
  const cols = [
    // 1) Cotizacion
    {
      content: () => (
        <td className={`px-2 py-1 max-w-[3.5rem] min-w-[3.5rem] w-[3.5rem] ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } z-10 sticky font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`} style={{ left: stickyOffsets?.first || '0rem' }}>
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              content={"Abrir cotización"}
              type="eye"
              action={() => handleOpenDrawer(s.cotizacion?.id)}
            />
          </div>
        </td>
      ),
    },

    // 2) %
    {
      content: () => (
        <td className={`px-2 py-1 max-w-[5rem] min-w-[5rem] w-[5rem] ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } z-10 max-w-xs sticky truncate font-bold text-center ${GetDynamicColor(s.porcentajeAvance, PercetageColor)}`} style={{ left: stickyOffsets?.second || '3.5rem' }}>
          <input
            type="number"
            value={s.porcentajeAvance ? s.porcentajeAvance : 0}
            min={0}
            max={100}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            onChange={(e) => {
              let value = parseInt(e.target.value, 10);
              if (isNaN(value)) value = 0;
              if (value < 0) value = 0;
              if (value > 100) value = 100;
              handleUpdateDate("porcentajeAvance", value);
            }}
            onWheel={(e) => e.target.blur()}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300 w-full ${GetDynamicColor(s.porcentajeAvance, PercetageColor)}`}
          />
        </td>
      ),
    },

    // 3) Cliente
    {
      content: () => (
        <td className={`sticky px-2 py-1 max-w-[10rem] ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } font-semibold truncate text-start hover:cursor-pointer hover:underline transition-all duration-100 z-10`} style={{ left: stickyOffsets?.third || '8.5rem' }}>
          <a href={`/home/seguimiento/${c.id}`} target="_blank" rel="noopener noreferrer" aria-label={`Abrir seguimiento de ${c.nombreComercial}`} />
          <span title={c.nombreComercial} className="whitespace-nowrap text-xs">
            {c.nombreComercial}{c.vip === "Si" && " ⭐"}
          </span>
        </td>
      ),
    },

    // 3) Checklist
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`${checklistCompleted === "Si" ? "text-green-500" : "text-red-500"}`}>
            {checklistCompleted}
          </span>
        </td>
      ),
    },

    // 4) Ir al proyecto
    {
      content: () => (
        <td className={`px-2 py-1 max-w-xs ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`}>
          <div className="flex justify-center items-center gap-2">
            <a
              href={`/home/seguimiento/${serviceData.cotizacion.cliente.id}/${serviceData.servicio.name}/${serviceData.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-row justify-center items-center gap-2 font-bold hover:cursor-pointer hover:underline transition-all duration-100"
            >
              <DetailsButton content={"Ir al proyecto"} type="externalLink"/>
            </a>
          </div>
        </td>
      ),
    },

    // 5) Tipo de web
    {
      content: () => (
        <td className="px-2 py-1 max-w-[100px] border border-gray-300 truncate text-center">
          {s.servicio?.name}
        </td>
      ),
    },

    // 6) Datos cliente
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              action={() => { setOpenModalClientData(true); setSelectedClientData(serviceData) }}
              content={"Abrir datos del cliente"}
            />
          </div>
        </td>
      ),
    },

    // 7) VIP
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <select
            value={s.cotizacion?.cliente?.vip}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            className={`text-xs w-[4rem] rounded-md px-2 py-1 border border-gray-300 ${vipClientColor[s.cotizacion?.cliente?.vip]}`}
            onChange={(e) => {
              HandleUpdateSelect("vip", e.target.value, s.cotizacion?.cliente?.id, "clientesUser", setClients)
              setS((prev) => ({
                ...prev,
                cotizacion: {
                  ...prev.cotizacion,
                  cliente: { ...prev.cotizacion?.cliente, vip: e.target.value }
                }
              }))
            }}
          >
            {vipClientValues.map((option) => (
              <option key={option.value} value={option.value} className={`${vipClientColor[option.value]}`}>{option.icon} {option.label}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 8) Link Drive
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            <DinamicBoxButton
              color={folderCreated && folderId ? "blue" : "gray"}
              action={folderCreated && folderId ? () => {window.open(driveUrl, "_blank", "noopener,noreferrer")} : null}
              content={driveUrl ? driveUrl : "No hay link de Drive"}
              icon={folderCreated && folderId ? <SiGoogledrive className="text-blue-500" /> : <FaEyeSlash className="text-gray-500"/>}
            />
          </div>
        </td>
      ),
    },

    // 9) Solicitud revisiones
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {s?.requestClientReviews?.length || 0}
            <DinamicBoxButton
              color={"blue"}
              action={() => onOpenSolicitudRevisiones?.(s.id)}
              content={`Solicitud revisiones`}
              icon={<FaFileAlt className="text-blue-500" />}
            />
          </div>
        </td>
      ),
    },

    // 10) Información enviada
    {
      content: () => (
        <td className="px-2 py-1 max-w-[120px] min-w-[120px] w-[120px] border border-gray-300 truncate text-center">
          <span className={`${infoEnviadaMapColor[s.informacionEnviada]}`}>
            <select
              value={s.informacionEnviada}
              onChange={(e) => {handleUpdateField("informacionEnviada", e.target.value)}}
              className={`text-xs w-full text-start rounded-md px-2 py-1 border border-gray-300
                ${s.informacionEnviada === "No envió nada" ? "text-red-500" :
                  s.informacionEnviada === "Envió poco" ? "text-yellow-400" :
                  s.informacionEnviada === "Envió todo" ? "text-green-500" :
                  "text-gray-500"}`}
              disabled={!permissions.isAdmin && !permissions.isUserArea}
            >
              <option value="Por confirmar" className="text-black">Por confirmar</option>
              <option value="No envió nada" className="text-red-500">No envió nada</option>
              <option value="Envió poco" className="text-yellow-400">Envió poco</option>
              <option value="Envió todo" className="text-green-500">Envió todo</option>
            </select>
          </span>
        </td>
      ),
    },

    // 11) Google Meet
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {s?.meets?.length || 0}
            <DinamicBoxButton
              color={"blue"}
              action={() => onOpenMeets?.(s.id)}
              content={`Ver reuniones`}
              icon={<FaCalendar className="text-blue-500" />}
            />
          </div>
        </td>
      ),
    },

    // 12) Regalo(?)
    {
      content: () => (
        <td className={`${s.servicioGratuito ? "bg-green-500 font-bold text-white" : "text-gray-200" } px-2 py-1 max-w-xs border border-gray-300 truncate text-center`}>
          {s.servicioGratuito ? `Gratis 🎁` : "No"}
        </td>
      ),
    },

    // 13) Enfoque web
    {
      content: () => (
        <td className="px-2 py-1 max-w-[120px] min-w-[120px] w-[120px] border border-gray-300 truncate text-center">
          <span className={`${infoEnviadaMapColor[s.informacionEnviada]}`}>
            <select
              value={s.enfoqueWeb}
              onChange={(e) => { handleUpdateField("enfoqueWeb", e.target.value) }}
              className={`text-xs rounded-md w-full text-start px-2 py-1 border border-gray-300 ${s.enfoqueWeb === "Normal" ? "text-blue-500" : s.enfoqueWeb === "Ads" ? "text-green-500" : "text-gray-500"}`}
              disabled={!permissions.isAdmin && !permissions.isUserArea}
            >
              {EnfoqueWebOptions.map((option) => (
                <option key={option.value} value={option.value} className={`${option.color}`}>{option.icon} {option.label}</option>
              ))}
            </select>
          </span>
        </td>
      ),
    },

    // 14) Recompra potencial
    {
      content: () => (
        <td className={`px-2 py-1 max-w-[120px] min-w-[120px] w-[120px] ${s.debt ? "bg-red-200" : "bg-white" } border border-gray-300 truncate text-center`}>
          <select
            value={s.cotizacion?.cliente?.recompraPotencial}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            onChange={(e) => {
              HandleUpdateSelect("recompraPotencial", e.target.value, s.cotizacion?.cliente?.id, "clientesUser", setClients)
              setS((prev) => ({
                ...prev,
                cotizacion: {
                  ...prev.cotizacion,
                  cliente: { ...prev.cotizacion?.cliente, recompraPotencial: e.target.value }
                }
              }))
            }}
            className={`text-xs rounded-md w-full text-start px-2 py-1 border border-gray-300`}
          >
            {OpcionesRecompraPotencial.map((value) => (
              <option key={value.value} value={value.value} className={`${value.color}`}>{value.icon} {value.label}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 15) Moroso
    {
      content: () => (
        <td className={`px-2 py-1 max-w-xs ${s.debt ? "bg-red-200" : "bg-white" } border border-gray-300 truncate text-center`}>
          <div className="flex justify-center items-center gap-2">
            {s.debt ? (
              <span className="text-red-500 font-bold">Si</span>
            ) : (
              <span className="text-gray-200">No</span>
            )}
          </div>
        </td>
      ),
    },

    // 16) ID Cotización
    {
      content: () => (
        <td className={`px-2 py-1 max-w-xs ${s.debt ? "bg-red-200" : "bg-white" } font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`}>
          <div className="flex justify-center items-center gap-2">
            <IdButton content={s.cotizacion.id} type="id" action={() => {CopyToClipBoard(s.cotizacion.id)}} />
          </div>
        </td>
      ),
    },

    // 17) Estado
    {
      content: () => (
        <td className={`px-2 py-1 max-w-[120px] min-w-[120px] w-[120px] border border-gray-300 text-center align-middle z-10`}>
          <select
            value={s.estado}
            onChange={(e) => {
              const newValue = e.target.value
              const missingFields = !s.delayResponsible || s.delayResponsible === "Por definir" || !s?.linkCapacitacion
              const noPrivilegedRole = !permissions.isAdmin && !permissions.isAssistant && !permissions.isBossArea
              if (noPrivilegedRole && missingFields && newValue === "Terminado con exito") {
                toast.error("Para colocar en estado 'Éxito', debe ser admin o asistente y completar responsable de retraso y link de capacitación.")
                return
              }
              if (newValue === "Congelado") {
                handleFreezeService(s.id)
                return
              }
              handleUpdateField("estado", newValue)
            }}
            className={`text-xs rounded-md w-full text-start px-2 py-1 border border-gray-300 
              ${(!permissions.isAdmin && !permissions.isAssistant && !permissions.isBossArea) ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}
              ${statusColorMap[s.estado] || ""}
            `}
            disabled={(!permissions.isAdmin && !permissions.isAssistant && !permissions.isBossArea) && s.estado !== "Terminado con exito"}
            title={(!permissions.isAdmin && !permissions.isAssistant && !permissions.isBossArea)? "No tienes permiso para editar el estado" : ""}
          >
            {webServiceStatus.map((status, i) => (
              <option key={i} value={status.value} className={`${status.color}`}>{status.icon} {status.label}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 18) Formulario
    {
      content: () => (
        <td className={`px-2 py-1 max-w-xs border font-bold border-gray-300 truncate text-center`}>
          <div className="flex justify-center items-center gap-2">
            {formStatus === "Respondido" ? (
              <a
                href={`/home/seguimiento/encuestas-respuestas/${s.form.id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <DetailsButton content={"Abrir formulario"} type="externalLink"/>
              </a>
            ) : (
              <Tooltip content={formStatus} >
                <div>
                  <FaEyeSlash className="text-gray-500"/>
                </div>
              </Tooltip>
            )}
          </div>
        </td>
      ),
    },

    // 19) Descripción servicio
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              action={() => {setOpenModalDescription(true); setSelectedService(s)}}
              content={"Abrir descripción del servicio"}
            />
          </div>
        </td>
      ),
    },

    // 20) Comentarios vendedor
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            {s.comentarioVendedor ? (
              <Tooltip content={s.comentarioVendedor} interactive={true}>
                <div className="flex justify-center items-center text-gray-800 hover:cursor-pointer">
                  <FaComment />
                </div>
              </Tooltip>
            ) : (
              <div className="flex justify-center items-center text-gray-200">
                <FaComment />
              </div>
            )}
          </div>
        </td>
      ),
    },

    // 21) Comentarios operativa
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            <DinamicBoxButton
              color={s?.comentariosOperativa?.length > 0 ? "blue" : "gray"}
              action={() => {setSelectedService(s); setOpenModalComments(true, { type: "default" })}}
              content={`Abrir comentarios del área operativa: ${s?.comentariosOperativa?.length > 0 ? `${s?.comentariosOperativa?.length}` : "0"}`}
              icon={s?.comentariosOperativa?.length > 0 ? <FaEye /> : <FaEyeSlash />}
            />
          </div>
        </td>
      ),
    },

    // 22) Plan
    {
      content: () => (
        <td className="px-1 py-1 max-w-[80px] min-w-[80px] w-[80px] border border-gray-300 truncate text-center">
          <span className={`font-semibold w-full text-start px-2 ${PlanBackgroundColor[s.planServicio.name]}`}>
            {s.planServicio.name}
          </span>
        </td>
      ),
    },

    // 23) Encargado
    {
      content: () => (
        <td className="max-w-[80px] min-w-[80px] w-[80px] px-2 py-1 border border-gray-300 truncate text-start">
          <span title={s.cotizacion?.cliente?.encargadoProyecto}>
            {s.cotizacion?.cliente?.encargadoProyecto ? `${s.cotizacion?.cliente?.encargadoProyecto}` : "-"}
          </span>
        </td>
      ),
    },

    // 24) Nro encargado
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.cotizacion?.cliente?.telefono ? `${s.cotizacion?.cliente?.telefono}` : "-"}
        </td>
      ),
    },

    // 25) Tipo cliente
    {
      content: () => (
        <td className="px-2 py-1 max-w-[120px] min-w-[120px] w-[120px] border border-gray-300 truncate text-center">
          <select
            value={s.cotizacion?.cliente?.tipoCliente}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            onChange={(e) => {
              HandleUpdateSelect("tipoCliente", e.target.value, s.cotizacion?.cliente?.id, "clientesUser", setClients)
              setS((prev) => ({
                ...prev,
                cotizacion: {
                  ...prev.cotizacion,
                  cliente: { ...prev.cotizacion?.cliente, tipoCliente: e.target.value }
                }
              }))
            }}
            className={`text-xs rounded-md w-full text-start px-2 py-1 border border-gray-300`}
          >
            <option value="No definido" className="text-gray-500">⚫ No definido</option>
            <option value="Amable" className="text-green-500">🟢	Amable</option>
            <option value="Normal" className="text-blue-500">🔵	 Normal</option>
            <option value="Problematico" className="text-red-500">🔴	 Problematico</option>
          </select>
        </td>
      ),
    },

    // 26) Responsable
    {
      content: () => (
        <td className="px-2 py-1 max-w-[6rem] min-w-[6rem] w-[6rem] border border-gray-300 truncate text-start">
          <select
            value={s.responsable?.id || ""}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            onChange={async (e) => {
              const responsableId = e.target.value === "" ? null : e.target.value;
              const selectedWorker = responsableId ? areaWorkers.find(w => w.id === responsableId) : null;
              const previousResponsable = s.responsable;

              setS((prev) => ({
                ...prev,
                responsable: selectedWorker
              }));

              try {
                const changeHistory = s.historialCambios ? [...s.historialCambios] : [];
                const newChange = {
                  worker: user,
                  field: "responsable",
                  oldValue: previousResponsable?.id || previousResponsable,
                  newValue: responsableId,
                  date: new Date().toISOString(),
                };
                changeHistory.push(newChange);

                const transformedHistory = changeHistory.map(change => ({
                  ...change,
                  worker: change.worker.id,
                }));

                await axios.put(`${BACKEND}/api/serviciosCotizaciones/${s.id}`, {
                  responsable: responsableId,
                  historialCambios: transformedHistory,
                });

                const updatedService = {
                  ...s,
                  responsable: selectedWorker,
                  historialCambios: changeHistory,
                };

                setS(updatedService);

                setClients((prevClients) =>
                  prevClients.map(client =>
                    client.id === c.id
                      ? {
                        ...client,
                        services: client.services.map(service =>
                          service.id === s.id ? updatedService : service
                        )
                      }
                      : client
                  )
                );

                toast.success("Responsable actualizado con éxito");
              } catch (error) {
                console.error(error);
                toast.error("Error al actualizar el responsable");
                setS((prev) => ({
                  ...prev,
                  responsable: previousResponsable
                }));
              }
            }}
            className={`text-xs rounded-md w-full text-start px-2 py-1 border border-gray-300`}
          >
            <option value="">-</option>
            {areaWorkers.map((worker) => (
              <option key={worker.id} value={worker.id}>{worker.name}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 27) Ingreso
    { content: () => (<td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">{s.fechaIngreso ? formatDate(s.fechaIngreso.split("T")[0]) : "-"}</td>) },

    // 28) Inicio
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaInicio ? s.fechaInicio.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaInicio", e.target.value)}
            disabled={(!permissions.isAdmin && !permissions.isBossArea)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 29) Inicio Manual
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaInicioManual ? s.fechaInicioManual.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaInicioManual", e.target.value)}
            disabled={(!permissions.isAdmin && !permissions.isBossArea)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 30) Fin
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaFin ? s.fechaFin.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaFin", e.target.value)}
            disabled={(!permissions.isAdmin && !permissions.isUserArea)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 31) Entrega
    { content: () => (<td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">{s.fechaEntrega ? formatDate(s.fechaEntrega.split("T")[0]) : "-"}</td>) },

    // 32) Grabación capacitación
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaGrabacionCapacitacion ? s.fechaGrabacionCapacitacion.split("T")[0] : ""}
            onChange={(e) => handleUpdateDate("fechaGrabacionCapacitacion", e.target.value)}
            disabled={
              Boolean(s.fechaGrabacionCapacitacion) ||
              (!permissions.isAdmin && !permissions.isBossArea)
            }
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 33) Migración oficial
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaMigracionOficial ? s.fechaMigracionOficial.split("T")[0] : ""}
            onChange={(e) => handleUpdateDate("fechaMigracionOficial", e.target.value)}
            disabled={
              Boolean(s.fechaMigracionOficial) ||
              (!permissions.isAdmin && !permissions.isBossArea)
            }
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 34) Fecha max envío info
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaInfoMax ? s.fechaInfoMax.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaInfoMax", e.target.value)}
            disabled={(!permissions.isAdmin && !permissions.isBossArea)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 35) Fecha envío info al 100%
    { content: () => (<td className="px-2 py-1 max-w-xs min-w-[5rem] border border-gray-300 truncate text-center">{s.fechaInfoCompleta ? formatDate(s.fechaInfoCompleta.split("T")[0]) : "-"}</td>) },

    // 36) Responsable retraso
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`${delayResponsibleMapColor[s.delayResponsible]}`}>
            <select
              value={s.delayResponsible}
              onChange={(e) => { handleUpdateField("delayResponsible", e.target.value) }}
              className={`text-xs rounded-md px-2 py-1 border border-gray-300
                ${s.delayResponsible === "No aplica" ? "text-gray-500" :
                  s.delayResponsible === "Cliente" ? "text-blue-500" :
                  s.delayResponsible === "Agencia" ? "text-red-500" :
                  "text-gray-500"}`}
              disabled={!permissions.isAdmin && !permissions.isUserArea}
            >
              {ResponsablesRetraso.map((r) => (
                <option key={r.value} value={r.value} className="text-black hover:cursor-pointer">{r.label}</option>
              ))}
            </select>
          </span>
        </td>
      ),
    },

    // 37) Fecha max pago
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaMaxPago ? s.fechaMaxPago.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaMaxPago", e.target.value)}
            disabled={!(permissions.isAdmin || permissions.isAssistant || permissions.isBossArea)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 38) Vendedor
    { content: () => (<td className="px-2 py-1 max-w-[100px] min-w-[100px] w-[100px] border border-gray-300 truncate text-center"><span className="w-full text-start" title={s.cotizacion?.cotizador?.name}>{s.cotizacion?.cotizador?.name ? `${s.cotizacion?.cotizador?.name}` : "-"}</span></td>) },

    // 39) Fecha inicio cobranza
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaCobranza ? s.fechaCobranza.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaCobranza", e.target.value)}
            disabled={!(permissions.isAdmin)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 40) Duración del proyecto establecido
    { content: () => (<td className="px-2 py-1 max-w-xs min-w-[10rem] border border-gray-300 truncate text-center">{Math.ceil((new Date(s.fechaFin).getTime() - new Date(s.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))}</td>) },

    // 41) Duración (hasta hoy si está en proceso)
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs min-w-[10rem] border border-gray-300 truncate text-center">
          {s.estado === 'Terminado con exito' ? (
            s.fechaInicio && s.fechaEntrega ? (
              Math.ceil((new Date(s.fechaEntrega).getTime() - new Date(s.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))
            ) : (
              "-"
            )
          ) : (
            s.fechaInicio ? (
              Math.ceil((new Date().getTime() - new Date(s.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))
            ) : (
              "-"
            )
          )}
        </td>
      ),
    },

    // 42) Fecha culminación operativa
    { content: () => (<td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">{s.fechaTermino ? formatDate(s.fechaTermino.split("T")[0]) : "-"}</td>) },

    // 43) Duración proyecto de operativa
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs min-w-[10rem] border border-gray-300 truncate text-center">
          {s.fechaInfoCompleta ? (
            s.estado === "En proceso"
              ? Math.ceil((new Date().getTime() - new Date(s.fechaInfoCompleta).getTime()) / (1000 * 60 * 60 * 24))
              : s.estado === "Terminado con exito" && s.fechaEntrega
                ? Math.ceil((new Date(s.fechaEntrega).getTime() - new Date(s.fechaInfoCompleta).getTime()) / (1000 * 60 * 60 * 24))
                : "N/A"
          ) : "N/A"}
        </td>
      ),
    },

    // 44) Duración real del proyecto
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs min-w-[10rem] border border-gray-300 truncate text-center">
          {s.fechaInfoCompleta ? (
            s.estado === "En proceso"
              ? Math.ceil((new Date().getTime() - new Date(s.fechaInfoCompleta).getTime()) / (1000 * 60 * 60 * 24))
              : s.estado === "Terminado con exito" && s.fechaEntrega
                ? Math.ceil((new Date(s.fechaEntrega).getTime() - new Date(s.fechaInfoCompleta).getTime()) / (1000 * 60 * 60 * 24))
                : "N/A"
          ) : "N/A"}
        </td>
      ),
    },

    // 45) Precio venta
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {(() => {
            const servicioEncontrado = webServices.find((e) => e.id === s.servicio.id);
            const precioUnitario = servicioEncontrado?.preciosUnitarios?.find((ev2) => ev2.plan?.id === s.planServicio?.id)?.precio;
            const precioBase = s.customPriceActive
              ? s.customPrice * s.numeroItems
              : precioUnitario
                ? precioUnitario * s.numeroItems
                : 0;
            let montoDescuento = 0;
            if (s.tipoDescuento === "Porcentaje") {
              montoDescuento = precioBase * (s.montoDescuento / 100);
            } else if (s.tipoDescuento === "Fijo") {
              montoDescuento = s.montoDescuento;
            }
            return "S/. " + (precioBase - montoDescuento).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          })()}
        </td>
      ),
    },

    // 46) Link desarrollo
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkDesarrollo ? (
              <DetailsButton
                action={() => {window.open(linkDesarrollo, "_blank")}}
                content={linkDesarrollo ? linkDesarrollo : "No hay link de desarrollo"}
              >
                {linkDesarrollo ? linkDesarrollo : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 47) Link oficial
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkOficial ? (
              <DetailsButton
                action={() => {window.open(linkOficial, "_blank")}}
                content={linkOficial ? linkOficial : "No hay link oficial"}
              >
                {linkOficial ? linkOficial : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 48) Web referencia
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {webReferencia ? (
              <DetailsButton
                action={() => {window.open(webReferencia, "_blank")}}
                content={webReferencia ? webReferencia : "No hay web referencia"}
              >
                {webReferencia ? webReferencia : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 49) Copia seguridad referencia
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {copiaSeguridadRef ? (
              <DetailsButton
                action={() => {window.open(copiaSeguridadRef, "_blank")}}
                content={copiaSeguridadRef ? copiaSeguridadRef : "No hay copia seguridad"}
              >
                {copiaSeguridadRef ? copiaSeguridadRef : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 50) Capacitación hecha
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`${capacitacionHechaMapColor[s.capacitacionHecha]}`}>
            {s.capacitacionHecha}
          </span>
        </td>
      ),
    },

    // 51) Link capacitación
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkCapacitacion ? (
              <DetailsButton
                action={() => {window.open(linkCapacitacion, "_blank")}}
                content={linkCapacitacion ? linkCapacitacion : "No hay link de capacitación"}
              >
                {linkCapacitacion ? linkCapacitacion : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 52) Link diseño gráfico
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkDisenioGrafico ? (
              <DetailsButton
                action={() => {window.open(linkDisenioGrafico, "_blank")}}
                content={linkDisenioGrafico ? linkDisenioGrafico : "No hay link oficial"}
              >
                {linkDisenioGrafico ? linkDisenioGrafico : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },
  ]

  const colsWithIds = cols.map((col, index) => ({ ...col, id: index + 1 }))

  return (
    <>
      {createPortal(
        <DrawerCotizacionCalendarioPagosDetails
          onClose={() => setOpenDrawer(false)}
          open={openDrawer}
          dataDrawer={dataDrawer}
          refetch={() => {}}
          isAdmin={permissions.isAdmin}
          paises={[]}
          currencyExchanges={[]}
        />,
        document.body
      )}
      <tr
        key={key}
        className={`text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300 ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" }`}
      >

        {/* Columnas dinámicas (ids 1..N) */}
        {colsWithIds.map((colDef) => {
          const isVisible = activeCols?.find((c) => c.id === colDef.id && shouldShowColumn(c))
          if (!isVisible) return null
          // content() devuelve un <td>, solo le añadimos key para React
          return React.cloneElement(colDef.content(), { key: colDef.id })
        })}

      </tr>
    </>
  )
}

export default WebRowItemContainer;